import { HFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Cns, Cpf } from 'components/label'
import { isUndefinedOrNull } from 'util/checks'

interface CodigoIdentificadorCidadaoProps {
  cpf: string | null | undefined
  cns: string | null | undefined
  dataCyPrefix?: string
}

export function CodigoIdentificadorCidadao(props: Readonly<CodigoIdentificadorCidadaoProps>) {
  const { cpf, cns, dataCyPrefix = 'CodigoIdentificador' } = props

  const hasCpf = !isUndefinedOrNull(cpf) && !cpf.isBlankOrEmpty()
  const hasCns = !isUndefinedOrNull(cns) && !cns.isBlankOrEmpty()

  const showCns = !hasCpf

  return (
    <HFlow hSpacing={1}>
      <HLabel title='CPF' data-cy={`${dataCyPrefix}.cpf`}>
        {hasCpf && <Cpf value={cpf} />}
      </HLabel>
      {showCns && (
        <HLabel title='CNS' data-cy={`${dataCyPrefix}.cns`}>
          {hasCns && <Cns value={cns} />}
        </HLabel>
      )}
    </HFlow>
  )
}
